export function isPrimitiveClass(classType) {
  return classType && (classType === Number || classType === String || classType === Boolean || classType === Date);
}
export function isPrimitiveType(object) {
  return object && (typeof object === 'number' || typeof object === 'string' || typeof object === 'boolean');
}